import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { Shield, Lock, CreditCard } from 'lucide-react';
export function Hero() {
  const handleScrollToPricing = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const target = document.getElementById('pricing');
    if (!target) return;
    const startY = window.scrollY;
    const endY = target.getBoundingClientRect().top + window.scrollY;
    const distance = endY - startY;
    const duration = 1500;
    let startTime: number | null = null;
    const easeInOutCubic = (t: number) => t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
    const step = (timestamp: number) => {
      if (startTime === null) startTime = timestamp;
      const elapsed = timestamp - startTime;
      const progress = Math.min(elapsed / duration, 1);
      window.scrollTo(0, startY + distance * easeInOutCubic(progress));
      if (progress < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  };
  return <section className="bg-cream pt-8 pb-12 md:pt-16 md:pb-16 px-4 relative overflow-hidden" data-id="element-95">
      <div className="absolute top-1/3 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[700px] bg-orange/5 rounded-full blur-[140px] pointer-events-none" data-id="element-96"></div>

      <div className="max-w-5xl mx-auto relative z-10 text-center" data-id="element-97">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-98">
          <span className="inline-block text-[10px] md:text-sm text-orange bg-white/5 border border-orange/40 rounded-full px-3 py-0.5 md:px-4 md:py-1 mb-3 md:mb-4 font-bold shadow-sm uppercase tracking-wider" data-id="element-99">
            🧠 EUREKALABS.STORE
          </span>

          <h1 className="font-heading font-black text-white mb-2 md:mb-4 text-2xl sm:text-3xl md:text-5xl lg:text-6xl leading-tight px-2 sm:px-8 max-w-4xl mx-auto tracking-tight" data-id="element-100">
            Your child's entire childhood of brain training —{' '}
            <span className="text-orange" data-id="element-101">solved.</span>
          </h1>

          <p className="font-bold text-base md:text-xl max-w-2xl mx-auto mb-3 leading-snug text-orange" data-id="element-102">
            Kit The Focused Mindset™ — The Ultimate Family Bundle, complete
            brain training system plus 5 bonus guides.
          </p>

          <p className="text-green font-bold text-base md:text-xl text-center" data-id="element-103">
            📄 100% PDF · ⚡ Instant Access · 🧠 Built for Real Family Life
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="mt-6 mb-4 md:mt-8 md:mb-6 flex justify-center" data-id="element-104">
          <img src="https://cdn.magicpatterns.com/uploads/goXZixZSyjdnqHbsTWBHXj/Diseno_sin_titulo_(17).png" alt="Kit The Focused Mindset" className="w-full max-w-[280px] md:max-w-[420px] mx-auto drop-shadow-[0_20px_50px_rgba(27,46,75,0.2)]" data-id="element-105" />
        </motion.div>

        <motion.p initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.3
      }} className="text-white/85 md:text-lg max-w-3xl mx-auto font-bold text-base mb-6" data-id="element-106">
          A done-for-you system packed with printable activities, focus
          structures, and ready-to-use brain training sessions for kids ages
          3–12. Open it, print it, and watch your child thrive — and reclaim
          your evenings for good.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.4
      }} className="max-w-2xl mx-auto" data-id="element-107">
          <a href="#pricing" onClick={handleScrollToPricing} className="inline-block bg-orange hover:bg-orange-dark text-white font-heading font-bold text-base md:text-xl py-4 px-8 md:py-5 md:px-12 rounded-full shadow-[0_10px_30px_rgba(249,115,22,0.4)] transition-all hover:scale-105 active:scale-95 mb-5 leading-tight cursor-pointer" data-id="element-108">
            → I WANT FOCUSED MINDSET NOW
          </a>

          <div className="flex flex-wrap justify-center gap-x-4 gap-y-2 md:gap-6 text-[12px] md:text-sm text-muted font-semibold" data-id="element-109">
            <div className="flex items-center" data-id="element-110">
              <Shield className="w-4 h-4 mr-1 text-green" data-id="element-111" /> Satisfied or
              Refunded in 7 Days
            </div>
            <div className="flex items-center" data-id="element-112">
              <Lock className="w-4 h-4 mr-1 text-green" data-id="element-113" /> Secure Payment
            </div>
            <div className="flex items-center" data-id="element-114">
              <CreditCard className="w-4 h-4 mr-1 text-green" data-id="element-115" /> One-time
              Payment
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}